<script setup>
import {Avatar} from "primevue";

defineProps({
    article: Object,
    horizontal: Boolean
})
</script>

<template>
    <a :href="`https://roori.app/blog/${article.slug}?utm_source=roori&utm_medium=login_post&utm_campaign=blogposts`">
        <article class="flex gap-3 cursor-pointer bg-white dark:bg-black rounded-2xl shadow-sm"
                 :class="!horizontal ? 'flex-col p-4':'items-center md:gap-3 p-2'">
            <div class="border dark:border-neutral-700 rounded-xl overflow-hidden" :class="!horizontal ? 'mt-0':'w-32'">
                <img :src="article.image" :class="horizontal ? 'h-24 w-32 object-cover' : 'h-40 w-full object-cover'"
                     alt="Image"/>
            </div>
            <div class="flex flex-col gap-2">
                <h1 class="text-base font-semibold">
                    {{ article.title }}
                </h1>
                <p class="text-sm text-gray-500 line-clamp-2">{{ article.annotation }}</p>
                <div class="flex items-center gap-2">
                    <Avatar shape="circle" :label="article.author.split(' ').map(el => el[0]).join('')" class="!text-xs"></Avatar>
                    <p class="text-xs text-gray-600 dark:text-white">{{ article.author }}</p>
                    <div class="text-xs text-gray-400 dark:text-white ml-auto">
                        {{ article.date }}
                    </div>
                </div>
            </div>
        </article>
    </a>
</template>

<style scoped>

</style>
